import { BackOffice } from './container'
export default BackOffice
